import { container } from 'tsyringe';
import { UipIconComponent } from './components';

export const bootstrapUip = () => {
  container.resolve(UipIconComponent)
    .render();
};
